export default __webpack_public_path__ + "static/media/failure-cross.095c9b0d.png";